// @flow

// Effect Managers
import { call } from 'redux-saga/effects'

// Constants
import {
  POST,
} from '../constants'

// Utils
import getBody from '../utils/getBody'

// Types
import type {
  GetFetchOptionsReturn,
  ComposePostArgs,
  PostArgs,
  PostResponse,
  Post,
} from '../../types'

// Exports
export default function ({
  getFetchOptions,
  getUrl,
  }: ComposePostArgs): Post {
  //
  return function *__get (
    { path, id, body, token, asFormData, excludeToken = false }: PostArgs
    //
  ): Generator<*, PostResponse, *> {
    //
    const options: GetFetchOptionsReturn = yield call(getFetchOptions, {
      type: POST,
      options: { body: getBody(body) },
      token,
      asFormData,
      excludeToken,
    })

    const url: string = getUrl({path, id})
    const response: Response = yield call(fetch, url, options)

    return response
  }
}
